import { Action, createReducer, on } from '@ngrx/store';
import {
  stockIsCreatedAction,
  removeRecentStockAction
} from 'src/app/actions/stock';

export interface StockState {
  stocks: any[];
  recentStock?: any | null;
}

export const initialState: StockState = {
  stocks: [],
  recentStock: null
};

const _stockReducer = createReducer(
  initialState,
  on(stockIsCreatedAction, (state, { newStock }) => ({
    ...state,
    stocks: [...state.stocks, newStock],
    recentStock: newStock
  })),
  on(removeRecentStockAction, state => ({
    ...state,
    recentStock: null
  }))
);

export function stockReducer(state: StockState | undefined, action: Action) {
  return _stockReducer(state, action);
}
